import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function Terms() {
  return (
    <LegalPage
      testid="page-terms"
      title="Terms of Service"
      intro={
        "These Terms of Service govern your access to and use of SERP — Shanvi Enterprise Resource Planning, provided by Shanvi Resources. By creating an account or using the service you agree to be bound by these terms."
      }
      sections={[
        {
          heading: "The service",
          paragraphs: [
            "SERP is a web-based operations suite for mining companies. Features include capital and operating cost planning, equipment and manpower planning, drill & blast calculations, profitability and sensitivity analysis, periodic operational reporting, AI insights and scheduled email exports.",
            "We may add, remove or change features from time to time. Your continued use of SERP after such changes constitutes acceptance of the updated service.",
          ],
        },
        {
          heading: "Accounts and workspaces",
          paragraphs: [
            "You are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account.",
            "The first user of a company workspace is the workspace administrator. Administrators may invite additional members and may remove members at any time.",
          ],
        },
        {
          heading: "Acceptable use",
          paragraphs: [
            "You agree not to (a) reverse engineer, decompile or otherwise attempt to derive the source code of SERP; (b) upload content that is unlawful, defamatory, or infringes any third-party right; (c) use SERP to send unsolicited email or spam; or (d) probe or test the vulnerability of the service without our written consent.",
          ],
        },
        {
          heading: "Your data",
          paragraphs: [
            "You retain all rights to the mining, financial and operational data you enter into SERP (your \"Data\"). You grant us a limited, non-exclusive licence to process your Data solely as necessary to provide the service.",
            "We do not use your Data to train third-party AI models. AI insights generated inside SERP use only the specific data you send to the AI endpoint at the moment of the request.",
          ],
        },
        {
          heading: "Fees and payment",
          paragraphs: [
            "SERP is provided free of charge during its trial period. When paid tiers are introduced, we will notify you at least thirty (30) days before charging your account, and you may cancel at any time before that date.",
          ],
        },
        {
          heading: "Warranties and liability",
          paragraphs: [
            "SERP is provided \"as is\" and \"as available\". To the maximum extent permitted by law, Shanvi Resources disclaims all warranties, express or implied, including but not limited to fitness for a particular purpose and non-infringement.",
            "Under no circumstances shall Shanvi Resources be liable for any indirect, incidental, special, consequential or punitive damages, or for any loss of profits, revenues or data, arising out of or in connection with your use of SERP.",
          ],
        },
        {
          heading: "Termination",
          paragraphs: [
            "You may close your workspace and delete your account at any time. We may suspend or terminate accounts that violate these terms.",
          ],
        },
        {
          heading: "Governing law",
          paragraphs: [
            "These Terms are governed by the laws of India, without regard to conflict-of-laws provisions. Any dispute arising under these Terms will be resolved in the courts of Odisha, India.",
          ],
        },
      ]}
    />
  );
}
